'use client';
import { InputAdornment, IconButton, TextField, TextFieldProps } from '@mui/material';
import { useTranslations } from 'next-intl';
import React from 'react';
import { useToggle } from '../../hooks';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const PasswordInput = (props: TextFieldProps) => {
    const t = useTranslations('login');
    const [showPassword, toggleShowPassword] = useToggle(false);

    return (
        <TextField
            label={t('input_pw')}
            type={showPassword ? 'text' : 'password'}
            InputProps={{
                endAdornment: (
                    <InputAdornment position='end'>
                        <IconButton
                            aria-label='toggle password visibility'
                            onClick={() => toggleShowPassword()}
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                )
            }}
            {...props}
        />
    );
};

export { PasswordInput };
